<adspt-spinner-overlay class="a-fx-col" [active]="loading">
    <div class="search-wrapper a-fx-none">
        <nz-input-group
            [nzPrefix]="prefixIconSearch"
            [ngClass]="{ disabled: hasAdvancedMode && showingAdvancedMode }"
            nz-tooltip
            nzTooltipPlacement="bottom"
            nzTooltipTitle="{{
                (hasAdvancedMode && showingAdvancedMode ? 'global-filter.group-selector.no-search-in-advancedmode' : '')
                    | translate
            }}"
        >
            <input
                type="text"
                nz-input
                placeholder="{{ texts.search }}"
                [adsptHeap]="heapInfo.search"
                [formControl]="formCtrl"
            />
        </nz-input-group>
        @if (hasAdvancedMode) {
            <div
                class="advanced"
                [ngClass]="{ active: hasAdvancedMode && showingAdvancedMode }"
                (click)="onAdvancedMode()"
                [adsptHeap]="heapInfo.switch"
                [heapData]="{ 'disable/enable': showingAdvancedMode }"
            >
                <svg class="adspt-icon">
                    <use xlink:href="#adspt-filter"></use>
                </svg>
            </div>
        }
    </div>

    @if (hasAdvancedMode && showingAdvancedMode) {
        <div class="advanced-section a-fx-none">
            <adspt-advanced-filter
                [filters]="subfilterOptions"
                [defaults]="defaultSubfiltersValues"
                source="pg"
                (filterChange)="onSubFilterChange($event)"
            ></adspt-advanced-filter>
        </div>
    }
    @if (!showingAdvancedMode && selectedItem) {
        <div class="selected-item">
            <div class="title">
                <p class="subtitle">{{ texts.selected }}</p>
            </div>
            <div class="item a-fx a-fx-start-center">
                <ng-container *ngTemplateOutlet="template; context: { $implicit: selectedItem }"></ng-container>
            </div>
        </div>
    }

    <div class="title all">
        <p class="subtitle">{{ texts.all }} {{ count | wrapInParenthesis }}</p>
    </div>

    <div
        class="items-list"
        [ngClass]="{ advanced: hasAdvancedMode && showingAdvancedMode }"
        (scroll)="onScroll($event)"
    >
        @if (!data?.length && !loading) {
            <p class="a-text-align-center p2 title" @fadeAnimation>
                {{ 'common.no-data' | translate }}
            </p>
        }
        @for (item of data; track item.id) {
            <div
                class="item a-fx a-fx-start-center a-fx-gap-8"
                [adsptHeap]="heapInfo.item"
                (click)="notfiy.emit({ payload: item, type: 'ITEM_CLICK' })"
                [ngClass]="{ disabled: item.id === selectedItem.id }"
                nz-tooltip
                nzTooltipTitle="{{ item.id !== selectedItem.id ? '' : ('common.already-selected' | translate) }}"
            >
                <ng-container *ngTemplateOutlet="template; context: { $implicit: item }"></ng-container>
            </div>
        }
    </div>

    @if (showingAdvancedMode) {
        <div
            class="actions a-fx a-fx-end-center a-fx-gap-8 a-fx-none"
            [ngClass]="{ disabled: !enabledApplySection }"
            nz-tooltip
            nzTooltipTitle="{{
                (!enabledApplySection ? 'global-filter.subfilter-selection-not-allowed' : '') | translate
            }}"
        >
            <button
                [adsptHeap]="heapInfo.reset"
                nz-tooltip
                [nzTooltipTitle]="'global-filter.reset-filters-tooltip' | translate"
                nzTooltipPlacement="top"
                nz-button
                nzType="default"
                (click)="notfiy.emit({ type: 'RESET' })"
            >
                {{ 'global-filter.reset-filters' | translate }}
            </button>
            <button
                [adsptHeap]="heapInfo.apply"
                [heapData]="{ 'destination/source': isDestinationFilterMode }"
                nz-tooltip
                [nzTooltipTitle]="texts.applyTooltip"
                nzTooltipPlacement="top"
                nz-button
                nzType="primary"
                (click)="notfiy.emit({ type: 'APPLY', payload: currentFilter })"
            >
                {{ 'global-filter.apply-filters' | translate }}
            </button>
        </div>
    }
</adspt-spinner-overlay>
<ng-template #prefixIconSearch>
    <svg class="adspt-icon">
        <use xlink:href="#adspt-zoom"></use>
    </svg>
</ng-template>
